// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Avada-Faq_FitIcon-Container.Avada-Faq_FitIcon-Container__zoomIn.chatty-icon svg{zoom:.6}.Avada-Faq_FitIcon-Container.Avada-Faq_FitIcon-Container__zoomIn svg{zoom:.4}.Avada-Faq_FitIcon-Container.chatty-icon svg{zoom:.9;margin-left:-1px}", ""]);
// Exports
module.exports = exports;
